export default function() {
  return this._root;
}



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/d3-quadtree/src/root.js
// module id = ../../../../d3-quadtree/src/root.js
// module chunks = 3